import React from "react";
import styles from "@/components/Comparison/Deals/styles.module.css";

const Search: React.FC<{
	handleSearch: (event: React.ChangeEvent<HTMLInputElement>) => void;
}> = ({ handleSearch }) => {
	return (
		<input
			className={`select search ${styles.deal__container}`}
			type="text"
			placeholder="Search..."
			onChange={handleSearch}
		/>
	);
};

export default Search;
